import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';

export const useEmbeddedMessagingCoreFeature = () => {
  return useFeatureFlag('EmbeddedMessagingCore', false);
};
